exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon[data-v-78c5f71e] {\n  width: 46px;\n}\n.step-label[data-v-78c5f71e] {\n  font-size: 16px;\n}\n.menu-item[data-v-78c5f71e] {\n  min-width: 47px;\n  margin-left: -24px;\n}\n@media screen and (max-width: 1030px) {\n.step-label[data-v-78c5f71e] {\n    display: none;\n}\n}\n@media screen and (max-width: 700px) {\n.menu-item[data-v-78c5f71e] {\n    min-width: 46px;\n    margin: 0;\n}\n.icon[data-v-78c5f71e] {\n    margin: 0;\n}\n}\n@media screen and (max-width: 400px) {\n.icon[data-v-78c5f71e] {\n    width: 35px;\n}\n.menu-item[data-v-78c5f71e] {\n    min-width: 35px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78c5f71e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/progressSideBar/ProgressStatus.vue
// module id = 666
// module chunks = 0